import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { exchangeSession } from "@/lib/auth";
import { toast } from "sonner";

/**
 * AuthCallback — exchanges the session_id from the URL fragment for an
 * httpOnly cookie via the backend, then navigates the user into /admin.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        // Strip hash and continue
        window.history.replaceState({}, "", window.location.pathname);
        toast(`Welcome, ${user.name?.split(" ")[0] || "admin"}`, {
          duration: 2400,
        });
        navigate("/admin", { replace: true, state: { user } });
      } catch (e) {
        const detail = e?.response?.data?.detail || "Sign-in failed";
        toast(detail, { duration: 3500 });
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <main
      data-testid="auth-callback"
      className="min-h-[100dvh] w-full flex items-center justify-center"
      style={{ backgroundColor: "var(--ld-ivory)" }}
    >
      <p className="font-accent text-[11px] tracking-[0.3em] text-[var(--ld-gold-deep)]">
        Signing you in…
      </p>
    </main>
  );
};

export default AuthCallback;
